<div>
  <app-board-menu (menuClick)="onMenuClick($event)"></app-board-menu>
  <app-board-task *ngIf="selectedMenuNumber === BoardSelectedMenuEnum.Task"></app-board-task>
  <app-board-cases *ngIf="selectedMenuNumber === BoardSelectedMenuEnum.Cases"></app-board-cases>
  <app-board-sales-order *ngIf="selectedMenuNumber === BoardSelectedMenuEnum.SalesOrder"></app-board-sales-order>
</div>
